import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {NavigationService_GetDrawerRecommendationsLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/service.grpc.lazy';
import {useOptionalSession} from '@aboutyou/user';
import {useFrequentlyUpdatingLastSeenProductIds} from '../../features/LastSeenProducts/useLastSeenProductIds';
import {useSelectedTargetGroup} from '../../shared-deprecated/useSelectedTargetGroup';
import {useNavigationCategory} from './useNavigationCategory';
import {OFFCANVAS_DEFAULT_QUERY_PARAMETER} from './useOffcanvasOpenState';

export const useRequestDrawerRecommendations = () => {
  const session = useOptionalSession();
  const lastSeenProductIds = useFrequentlyUpdatingLastSeenProductIds();
  const {currentCategoryId} = useNavigationCategory();
  const {targetGroup} = useSelectedTargetGroup();

  return useGrpcRequest(NavigationService_GetDrawerRecommendationsLazy, {
    lastSeenProductIds,
    session,
    identifier:
      currentCategoryId &&
      currentCategoryId !== OFFCANVAS_DEFAULT_QUERY_PARAMETER
        ? {
            $case: 'category',
            category: {
              identifier: {
                $case: 'id',
                id: +currentCategoryId,
              },
            },
          }
        : {
            $case: 'targetGroup',
            targetGroup,
          },
  });
};
